import { BaseURL, httpClient } from './base/httpClient';


export async function GetCliente() {
    var tokenKey = localStorage.getItem("k_")?? "";

    const apiResponse = await httpClient.get(BaseURL + "/selfie/get-dados-cliente",
        {
            headers: {
                token: tokenKey
            }
        });

    return apiResponse;
}